import { GzIntegrityMonitorRuleSetsWebComponent } from './component/GzIntegrityMonitorRuleSetsWebComponent';

export { GzIntegrityMonitorRuleSetsWebComponent };
